"use strict";
exports.__esModule = true;
exports.Guid = exports.globals = void 0;
exports.globals = {
    guidDefaultValue: '00000000-0000-0000-0000-000000000000',
    validationPattern: '^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$'
};
var Guid = /** @class */ (function () {
    function Guid(guid) {
        var _this = this;
        /*
         * Comparing string `value` against provided `guid` will auto-call
         * toString on `guid` for comparison
         */
        this.equals = function (other) { return Guid.isGuid(other) && _this.value.toUpperCase() === other.toString().toUpperCase(); };
        this.isEmpty = function () { return _this.value === exports.globals.guidDefaultValue; };
        this.toString = function () { return _this.value; };
        if (!guid)
            throw new TypeError('Invalid argument; `value` has no value.');
        this.value = exports.globals.guidDefaultValue;
        if (guid && Guid.isGuid(guid))
            this.value = guid;
    }
    Guid.gen = function (count) {
        if (count === void 0) { count = 1; }
        var out = '';
        for (var i = 0; i < count; i++)
            out += ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        return out;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Guid.prototype.toJSON = function () { return { value: this.value }; };
    Guid.validator = new RegExp(exports.globals.validationPattern, 'i');
    Guid.isGuid = function (guid) { return guid && (guid instanceof Guid || Guid.validator.test(guid.toString())); };
    Guid.create = function () { return new Guid([Guid.gen(2), Guid.gen(), Guid.gen(), Guid.gen(), Guid.gen(3)].join('-')); };
    Guid.createEmpty = function () { return new Guid(exports.globals.guidDefaultValue); };
    Guid.parse = function (guid) { return new Guid(guid); };
    Guid.raw = function () { return [Guid.gen(2), Guid.gen(), Guid.gen(), Guid.gen(), Guid.gen(3)].join('-'); };
    Guid.EMPTY = Guid.parse(exports.globals.guidDefaultValue);
    return Guid;
}());
exports.Guid = Guid;
